import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-check-role-modal',
    templateUrl: './check-modal.component.html',
    styleUrls: ['./check-modal.component.scss'],
    standalone: false
})

export class CheckRoleModalComponent {
  constructor(public dialogRef: MatDialogRef<CheckRoleModalComponent>) {
  }

}
